import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, tap } from 'rxjs';

import { AppActions } from '.';
import { TokenService } from '../core/service/token.service';
import { AuthService } from '../core/service/auth.service';
import { PermissionApiService } from '../shared/api/services/permission-api.service';
import { DictionaryUserTableVisualizationApiService } from '../shared/api/services/dictionary-user-table-visualization-api.service';

/**
 * Effetti che agiscono sull'intera app
 */
@Injectable()
export class AppEffects {
  constructor(
    private actions$: Actions,
    private tokenService: TokenService,
    private authService: AuthService,
    private permissionService: PermissionApiService,
    private moduleService: DictionaryUserTableVisualizationApiService,//UserTableVisualizationApiService,
    private router: Router
  ) {}

  $setToken = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.setToken),
      tap((action) => this.tokenService.setToken(action.token)),
      mergeMap(() => [AppActions.loadUser(), AppActions.loadPermission(), AppActions.loadModules(), AppActions.loadGroup()])
    )
  );

  $getUser = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.loadUser),
      mergeMap(() =>
        this.authService.getUser().pipe(
          map((response) =>{
            localStorage.setItem('user_id', response.pk.toString()); // optional if needed
            return AppActions.loadUserSuccess({ user: response });
          }),
          //AppActions.loadUserSuccess({ user: response })),
          catchError((response) =>
            of(AppActions.loadUserFailure({ response: response }))
          )
        )
      )
    )
  );
  $getGroup = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.loadGroup),
      mergeMap(() =>
        this.authService.getGroups(localStorage.getItem('user_id')!).pipe(
          map((response) => AppActions.loadGroupSuccess({ group: response.results})),
          catchError((response) =>
            of(AppActions.loadGroupFailure({ response: response }))
          )
        )
      )
    )
  )
  $getPermission = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.loadPermission),
      mergeMap(() =>
        this.permissionService.getAll().pipe(
          map((response) =>
            AppActions.loadPermissionSuccess({ permissions: response })
          ),
          catchError((response) =>
            of(AppActions.loadPermissionFailure({ response: response }))
          )
        )
      )
    )
  );
  
  $getModules = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.loadModules),
      mergeMap(() =>
        this.moduleService.getAll().pipe(
          map((response) =>
            AppActions.loadModulesSuccess({ modules: response})
          ),
          catchError((response) =>
            of(AppActions.loadPermissionFailure({ response: response }))
          )
        )
      )
    )
  );

  $getUserFailure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AppActions.loadUserFailure, AppActions.loadPermissionFailure),
        tap(() => {
          //TODO show error message
          this.tokenService.clearToken();
        })
      ),
    { dispatch: false }
  );

  $logOut = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.logOut),
      mergeMap(() =>
        this.authService.logOut().pipe(
          map(() => AppActions.logOutSuccess()),
          catchError((err) => of(AppActions.logOutFailure({ response: err })))
        )
      )
    )
  );

  $logOutSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AppActions.logOutSuccess),
        tap(() => {
          this.tokenService.clearToken();
          this.router.navigate(['/login']);
        })
      ),
    {
      dispatch: false,
    }
  );

  $logOutFailure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AppActions.logOutFailure),
        tap((err) => {
          console.log(err);
          //TODO show error message
        })
      ),
    {
      dispatch: false,
    }
  );
}
